import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "home-input" }
const _hoisted_2 = { class: "box_container" }
const _hoisted_3 = { class: "box_input" }
const _hoisted_4 = { class: "box_input__title" }
const _hoisted_5 = { class: "box_input__body" }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "box" }
const _hoisted_8 = {
  key: 0,
  "data-testid": `input_file_content`,
  class: "dz-file-preview dz-preview"
}
const _hoisted_9 = {
  key: 0,
  class: "dz-file-preview-zip dz-details"
}
const _hoisted_10 = { class: "file-name-and-size" }
const _hoisted_11 = ["data-testid", "onClick"]
const _hoisted_12 = {
  key: 1,
  class: "dz-details"
}
const _hoisted_13 = { class: "file-name-and-size" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "dz-default"
}
const _hoisted_16 = { class: "dropzone_output" }
const _hoisted_17 = { class: "form-label" }
const _hoisted_18 = { class: "form-label" }
const _hoisted_19 = { class: "form-label" }
const _hoisted_20 = { class: "form-label" }
const _hoisted_21 = { class: "form-label" }
const _hoisted_22 = { class: "form-label" }
const _hoisted_23 = { class: "py-30px box_input__button-container" }
const _hoisted_24 = { class: "box-input-file-settings" }
const _hoisted_25 = { class: "box-input-file-settings__tabs" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "box-input-file-settings__box"
}
const _hoisted_28 = {
  key: 0,
  class: "box-input-file-settings--inventory"
}
const _hoisted_29 = { class: "box-input-file-settings__button-container" }
const _hoisted_30 = {
  key: 1,
  class: "box-input-file-settings__empty"
}
const _hoisted_31 = {
  key: 1,
  class: "box-input-file-settings__box"
}
const _hoisted_32 = {
  key: 0,
  class: "box-input-file-settings--sales-result"
}
const _hoisted_33 = { class: "box-input-file-settings__button-container" }
const _hoisted_34 = {
  key: 1,
  class: "box-input-file-settings__empty"
}
const _hoisted_35 = {
  key: 2,
  class: "box-input-file-settings__box"
}
const _hoisted_36 = {
  key: 0,
  class: "box-input-file-settings--arrival"
}
const _hoisted_37 = { class: "box-input-file-settings__button-container" }
const _hoisted_38 = {
  key: 1,
  class: "box-input-file-settings__empty"
}
const _hoisted_39 = {
  key: 3,
  class: "box-input-file-settings__box"
}
const _hoisted_40 = {
  key: 0,
  class: "box-input-file-settings--order"
}
const _hoisted_41 = { class: "box-input-file-settings__button-container" }
const _hoisted_42 = {
  key: 1,
  class: "box-input-file-settings__empty"
}

import FileInput from '@/components/input/FileInput.vue';
import Flex from '@/components/atom/Flex.vue';
import { i18n } from '@/i18n';
import { computed, onMounted, ref } from 'vue';
import InputExcelForm from '../inputExcelForm/InputExcelForm.vue';
import InputOrderExcelForm from '../inputExcelForm/InputOrderExcelForm.vue';
import { useImportExcelStore } from '../../ImportExcelStore';
import ResultRegisteredAnnounceModal from '@/registerInputModule/pages/components/ResultRegisteredAnnounceModal.vue';
import { RegisterSettingStore } from '../../RegisterSettingStore';
import { storeToRefs } from 'pinia';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { useRouter } from 'vue-router';
import { InputFileType, inputFileTypes } from '@/coreDomainsModule/entities/inputExcelInfo';
import { assertNever } from '@/coreDomainsModule/assertNever';
import type { RegisterOrderExcelInfos } from '@/coreDomainsModule/entities/InputOrderExcelInfo';

// STOPSHIP: ざっくり移行しているだけなので、リファクタ必須
/**
 * ホーム画面上で年月情報を編集できる入力ファイルタイプ
 */
type StandardInputFileType = Exclude<InputFileType, 'Order'>;


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeInput',
  props: {
    registerSettingStore: {}
  },
  setup(__props: any) {

const store = useImportExcelStore();
const importExcelState = store.state;
const router = useRouter();

const props = __props;
const { state } = storeToRefs(props.registerSettingStore);

const t = i18n.t;
const fileInputRef1 = ref();
const fileInputRef2 = ref();
const fileInputRef3 = ref();
const fileInputRef4 = ref();
const fileInputRef5 = ref();
const fileInputRef6 = ref();
const fileInputRef7 = ref();
const fileInputRef8 = ref();

const isInputProcessing = ref(false);

onMounted(async () => {
  await props.registerSettingStore.fetchInputHomeData();
  store.setupFileInputRef(
    fileInputRef1,
    fileInputRef2,
    fileInputRef3,
    fileInputRef4,
    fileInputRef5,
    fileInputRef6,
    fileInputRef7,
    fileInputRef8
  );
});

const importData = computed(() => {
  return store.importUpdateData(importExcelState.importFlags);
});

// 少なくとも 1 つのファイルが選択されていることをチェックする
const checkSelectedFileExport = computed(() => {
  return Object.keys(store.outputFileSelectionButton.value).some((key) => store.outputFileSelectionButton.value[key].active);
});

/**
 * 登録スタートボタンの有効/無効を判定する
 */
const availableStartButton = computed(() => {
  return (
    (!(importData.value && (checkSelectedFileExport.value || importExcelState.translateMode === 'updateExcel')) ||
      state.value.homeInput.isEdited.Inventory ||
      state.value.homeInput.isEdited.SalesResults ||
      state.value.homeInput.isEdited.Arrival) &&
    !isInputProcessing.value
  );
});

/**
 * setter
 * @param inputFileType - ファイルタイプ
 * @param updateValue - 更新する値
 */
const updateInlineHeaderName = (inputFileType: StandardInputFileType, updateValue: string) => {
  const inputExcelInfo = state.value.homeInput.inputExcelInfo?.[inputFileType];
  if (!inputExcelInfo) {
    return;
  }
  inputExcelInfo.inlinedYearMonthHeaderName = {
    headerName: updateValue,
    validateError: 'none',
  };
  state.value.homeInput.isEdited[inputFileType] = true;
};

/**
 * setter
 * @param inputFileType - ファイルタイプ
 * @param updateValue - 更新する値
 */
const updateInHeaderStartColumnNumber = (inputFileType: StandardInputFileType, updateValue: string) => {
  const inputExcelInfo = state.value.homeInput.inputExcelInfo?.[inputFileType];
  const inHeaderYearMonthInfo = inputExcelInfo?.inHeaderYearMonthInfo;
  if (!inputExcelInfo || !inHeaderYearMonthInfo) {
    return;
  }
  inputExcelInfo.inHeaderYearMonthInfo = {
    ...inHeaderYearMonthInfo,
    startColumnNumber: {
      ...inHeaderYearMonthInfo.startColumnNumber,
      raw: updateValue,
    },
  };
  state.value.homeInput.isEdited[inputFileType] = true;
};

/**
 * setter
 * @param inputFileType - ファイルタイプ
 * @param updateValue - 更新する値
 */
const updateInHeaderEndColumnNumber = (inputFileType: StandardInputFileType, updateValue: string) => {
  const inputExcelInfo = state.value.homeInput.inputExcelInfo?.[inputFileType];
  const inHeaderYearMonthInfo = inputExcelInfo?.inHeaderYearMonthInfo;
  if (!inputExcelInfo || !inHeaderYearMonthInfo) {
    return;
  }
  inputExcelInfo.inHeaderYearMonthInfo = {
    ...inHeaderYearMonthInfo,
    endColumnNumber: {
      ...inHeaderYearMonthInfo.endColumnNumber,
      raw: updateValue,
    },
  };
  state.value.homeInput.isEdited[inputFileType] = true;
};

/**
 * setter
 * @param inputFileType - ファイルタイプ
 * @param updateValue - 更新する値
 */
const updateInHeaderStart = (inputFileType: StandardInputFileType, updateValue: string) => {
  const inputExcelInfo = state.value.homeInput.inputExcelInfo?.[inputFileType];
  const inHeaderYearMonthInfo = inputExcelInfo?.inHeaderYearMonthInfo;
  if (!inputExcelInfo || !inHeaderYearMonthInfo) {
    return;
  }
  inputExcelInfo.inHeaderYearMonthInfo = {
    ...inHeaderYearMonthInfo,
    start: {
      ...inHeaderYearMonthInfo.start,
      raw: updateValue,
    },
  };
  state.value.homeInput.isEdited[inputFileType] = true;
};

/**
 * setter
 * @param inputFileType - ファイルタイプ
 * @param updateValue - 更新する値
 */
const updateInHeaderEnd = (inputFileType: StandardInputFileType, updateValue: string) => {
  const inputExcelInfo = state.value.homeInput.inputExcelInfo?.[inputFileType];
  const inHeaderYearMonthInfo = inputExcelInfo?.inHeaderYearMonthInfo;
  if (!inputExcelInfo || !inHeaderYearMonthInfo) {
    return;
  }
  inputExcelInfo.inHeaderYearMonthInfo = {
    ...inHeaderYearMonthInfo,
    end: {
      ...inHeaderYearMonthInfo.end,
      raw: updateValue,
    },
  };
  state.value.homeInput.isEdited[inputFileType] = true;
};

/**
 * ホーム画面上の発注取込設定を更新する
 * @param orderExcelInfos - 更新後の発注取込設定一覧
 */
const updateHomeOrderExcelInfos = (orderExcelInfos: RegisterOrderExcelInfos) => {
  if (!state.value.homeInput.inputExcelInfo) return;
  state.value.homeInput.inputExcelInfo = {
    ...state.value.homeInput.inputExcelInfo,
    Order: orderExcelInfos,
  };
  state.value.homeInput.isEdited.Order = true;
};

/**
 * ホーム画面上の発注取込設定を削除して保存する
 * @param orderExcelInfos - 削除後の発注取込設定一覧
 */
const removeHomeOrderExcelInfo = async (orderExcelInfos: RegisterOrderExcelInfos) => {
  updateHomeOrderExcelInfos(orderExcelInfos);
  await props.registerSettingStore.onClickHomeInputUpdateData('Order');
};

/**
 * ホーム画面上の発注取込設定名を保存する
 */
const confirmHomeOrderExcelInfoName = async () => {
  await props.registerSettingStore.onClickHomeInputUpdateData('Order');
};

/**
 * 登録スタートボタン押下時のハンドラ
 */
const handleConfirm = async () => {
  isInputProcessing.value = true;
  const el = document.activeElement;
  if (el instanceof HTMLElement) el.blur();
  const response = await store.openTranslateExcelModal();
  if (response && response.pushToOrderPage) {
    router.push('/order');
  }
  isInputProcessing.value = false;
};

const selectedInputSetting = ref<InputFileType>('Inventory');

/**
 * タイプ
 * @param type - 変更するタイプ
 */
const selectInputSetting = (type: InputFileType) => {
  selectedInputSetting.value = type;
};

/**
 * ファイルタイプに応じたタイトルのラベルを返す
 * @param type - タイプ
 */
const getTitleByInputFileType = (type: InputFileType) => {
  switch (type) {
    case 'Inventory':
      return '在庫ファイル';
    case 'Arrival':
      return '入荷ファイル';
    case 'SalesResults':
      return '販売実績ファイル';
    case 'Order':
      return '発注取込ファイル';
    default:
      assertNever(type);
      return '';
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, [
          _createTextVNode(_toDisplayString(_unref(t)('入力（ドラッグ&ドロップまたはファイル選択）')), 1),
          _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('※ファイル名の冒頭（在庫表_など）と拡張子は入力規則に則ってください')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _mergeProps(_unref(store).getRootProps(), { class: "mb-20px dropzone" }), [
                _createElementVNode("input", _mergeProps(_unref(store).getInputProps(), { "data-testid": `dropzone_input_area` }), null, 16),
                (_unref(importExcelState).files.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(importExcelState).files, (file, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "dz-file-content"
                        }, [
                          (_unref(store).isZipFile(file))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("span", null, _toDisplayString(_unref(store).fetchNameForEvent(file)), 1),
                                  _createElementVNode("span", null, _toDisplayString(_unref(store).getFileSizeStr(file)), 1)
                                ]),
                                _createElementVNode("span", {
                                  "data-testid": `dropzone_item_delete_button_${index}`,
                                  class: "dz-remove",
                                  onClick: _withModifiers(($event: any) => (_unref(store).handleClickDeleteFile(index)), ["stop"])
                                }, _toDisplayString(_unref(t)('削除')), 9, _hoisted_11)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("span", null, _toDisplayString(_unref(store).fetchNameForEvent(file)), 1),
                                  _createElementVNode("span", null, _toDisplayString(_unref(store).getFileSizeStr(file)), 1)
                                ]),
                                _createElementVNode("span", {
                                  class: "dz-remove",
                                  onClick: _withModifiers(($event: any) => (_unref(store).handleClickDeleteFile(index)), ["stop"])
                                }, " Delete ", 8, _hoisted_14)
                              ]))
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["dz-message", _unref(store).isDragActive])
                      }, [
                        _cache[23] || (_cache[23] = _createElementVNode("i", null, null, -1)),
                        _createElementVNode("p", null, _toDisplayString(_unref(t)('ここにファイルをドロップ')), 1)
                      ], 2)
                    ]))
              ], 16),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(Flex, {
                  "flex-direction": 'column',
                  "align-items": 'baseline'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('在庫ファイル') + `（${_unref(t)('在庫_XXX.xlsx')}）`), 1),
                    _createVNode(Flex, null, {
                      default: _withCtx(() => [
                        _createVNode(FileInput, {
                          ref_key: "fileInputRef2",
                          ref: fileInputRef2,
                          "data-testid": `input_inventory_excel_button`,
                          "prop-file-name": _unref(store).fetchFileName('在庫'),
                          class: "file-input",
                          label: _unref(t)('Excel取込'),
                          onChange: _cache[0] || (_cache[0] = ($event) => _unref(store).fileRead($event, '在庫', false, 'xlsx'))
                        }, null, 8, ["prop-file-name", "label"])
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(Flex, {
                  "flex-direction": 'column',
                  "align-items": 'baseline'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('内示ファイル') + `（${_unref(t)('内示_XXX.zip')}）`), 1),
                    _createVNode(Flex, null, {
                      default: _withCtx(() => [
                        _createVNode(FileInput, {
                          ref_key: "fileInputRef1",
                          ref: fileInputRef1,
                          "data-testid": `input_announce_excel_button`,
                          "prop-file-name": _unref(store).fetchFileName('内示'),
                          class: "file-input",
                          label: _unref(t)('Zip取込'),
                          onChange: _cache[1] || (_cache[1] = ($event) => _unref(store).createIBusinessFromZip($event, false))
                        }, null, 8, ["prop-file-name", "label"])
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(Flex, {
                  "flex-direction": 'column',
                  "align-items": 'baseline'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('日別内示ファイル') + `（${_unref(t)('日別内示_XXX.zip')}）`), 1),
                    _createVNode(Flex, null, {
                      default: _withCtx(() => [
                        _createVNode(FileInput, {
                          ref_key: "fileInputRef7",
                          ref: fileInputRef7,
                          "data-testid": `input_daily_announce_excel_button`,
                          "prop-file-name": _unref(store).fetchFileName('日別内示'),
                          class: "file-input",
                          label: _unref(t)('Zip取込'),
                          onChange: _cache[2] || (_cache[2] = ($event) => _unref(store).createIBusinessFromDailyZip($event, false))
                        }, null, 8, ["prop-file-name", "label"])
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(Flex, {
                  "flex-direction": 'column',
                  "align-items": 'baseline'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('販売実績ファイル') + `（${_unref(t)('販売実績_XXX.xlsx')}）`), 1),
                    _createVNode(Flex, null, {
                      default: _withCtx(() => [
                        _createVNode(FileInput, {
                          ref_key: "fileInputRef3",
                          ref: fileInputRef3,
                          "data-testid": `input_sales_results_excel_button`,
                          "prop-file-name": _unref(store).fetchFileName('販売実績'),
                          class: "file-input",
                          label: _unref(t)('Excel取込'),
                          onChange: _cache[3] || (_cache[3] = ($event) => _unref(store).fileRead($event, '販売実績', false, 'xlsx'))
                        }, null, 8, ["prop-file-name", "label"])
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(Flex, {
                  "flex-direction": 'column',
                  "align-items": 'baseline'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('入荷ファイル') + `（${_unref(t)('入荷_XXX.xlsx')}）`), 1),
                    _createVNode(Flex, null, {
                      default: _withCtx(() => [
                        _createVNode(FileInput, {
                          ref_key: "fileInputRef4",
                          ref: fileInputRef4,
                          "data-testid": `input_arrival_excel_button`,
                          "prop-file-name": _unref(store).fetchFileName('入荷'),
                          class: "file-input",
                          label: _unref(t)('Excel取込'),
                          onChange: _cache[4] || (_cache[4] = ($event) => _unref(store).fileRead($event, '入荷', false, 'xlsx'))
                        }, null, 8, ["prop-file-name", "label"])
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(Flex, {
                  "flex-direction": 'column',
                  "align-items": 'baseline'
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('発注取込ファイル') + `（${_unref(t)('発注取込_XXX.xlsx')}）`), 1),
                    _createVNode(Flex, null, {
                      default: _withCtx(() => [
                        _createVNode(FileInput, {
                          ref_key: "fileInputRef8",
                          ref: fileInputRef8,
                          "data-testid": `input_order_excel_button`,
                          "prop-file-name": _unref(store).fetchFileName('発注取込'),
                          class: "file-input",
                          label: _unref(t)('Excel取込'),
                          onChange: _cache[5] || (_cache[5] = ($event) => _unref(store).fileRead($event, '発注取込', false, 'xlsx'))
                        }, null, 8, ["prop-file-name", "label"])
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(TextButton, {
                  "button-style": 'btn-secondary',
                  size: 'btn-md',
                  "on-click": _ctx.registerSettingStore.onClickHomeInputBack,
                  disabled: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('戻る')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["on-click"]),
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "box_input__button-container--spacer" }, null, -1)),
                _createVNode(TextButton, {
                  "button-style": 'btn-secondary-error',
                  size: 'btn-md',
                  "on-click": _unref(store).removeAllFile,
                  disabled: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('リセット')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["on-click"]),
                _createVNode(TextButton, {
                  "button-style": 'btn-primary',
                  size: 'btn-md',
                  "on-click": handleConfirm,
                  disabled: availableStartButton.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('登録スタート')), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(inputFileTypes), (type) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `input-setting-${type}`,
              class: _normalizeClass(["box-input-file-settings__tab", {
              'box-input-file-settings__tab--active': type === selectedInputSetting.value,
            }])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "box-input-file-settings__tab__label",
                onClick: ($event: any) => (selectInputSetting(type))
              }, _toDisplayString(_unref(t)(getTitleByInputFileType(type))), 9, _hoisted_26)
            ], 2))
          }), 128))
        ]),
        (selectedInputSetting.value === 'Inventory')
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              (_unref(state).homeInput.inputExcelInfo && _unref(state).homeInput.inputExcelInfo.Inventory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(InputExcelForm, {
                      from: 'HomeInput',
                      "selected-field-id": '',
                      suggestions: [],
                      "use-format-type": _unref(state).homeInput.inputExcelInfo?.Inventory.selectYearMonthPattern,
                      "alterable-header-infos": _unref(state).homeInput.inputExcelInfo.Inventory.alternateHeaderInfos,
                      "inlined-year-month-info": 
                _unref(state).homeInput.inputExcelInfo.Inventory.inlinedYearMonthHeaderName || {
                  headerName: '',
                  validateError: 'none',
                }
              ,
                      "in-header-year-month-info": 
                _unref(state).homeInput.inputExcelInfo.Inventory.inHeaderYearMonthInfo || {
                  startColumnNumber: {
                    raw: '',
                    validateError: 'none',
                  },
                  endColumnNumber: {
                    raw: '',
                    validateError: 'none',
                  },
                  start: {
                    raw: '',
                    validateError: 'none',
                  },
                  end: {
                    raw: '',
                    validateError: 'none',
                  },
                }
              ,
                      onUpdateInlineHeaderName: _cache[6] || (_cache[6] = ($event: any) => (updateInlineHeaderName('Inventory', $event))),
                      onUpdateInHeaderStartColumnNumber: _cache[7] || (_cache[7] = ($event: any) => (updateInHeaderStartColumnNumber('Inventory', $event))),
                      onUpdateInHeaderEndColumnNumber: _cache[8] || (_cache[8] = ($event: any) => (updateInHeaderEndColumnNumber('Inventory', $event))),
                      onUpdateInHeaderStart: _cache[9] || (_cache[9] = ($event: any) => (updateInHeaderStart('Inventory', $event))),
                      onUpdateInHeaderEnd: _cache[10] || (_cache[10] = ($event: any) => (updateInHeaderEnd('Inventory', $event)))
                    }, null, 8, ["use-format-type", "alterable-header-infos", "inlined-year-month-info", "in-header-year-month-info"]),
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "box-input-file-settings__separator" }, null, -1)),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(TextButton, {
                        "button-style": 'btn-secondary',
                        size: 'btn-md',
                        "on-click": 
                  () => {
                    _ctx.registerSettingStore.onClickHomeInputSettingData('在庫');
                  }
                ,
                        disabled: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('取引設定：取引設定ボタン')), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["on-click"]),
                      _createVNode(TextButton, {
                        "button-style": 'btn-primary',
                        size: 'btn-md',
                        "on-click": 
                  () => {
                    _ctx.registerSettingStore.onClickHomeInputUpdateData('Inventory');
                  }
                ,
                        disabled: !_unref(state).homeInput.isEdited.Inventory
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('取引設定：年月情報変更ボタン')), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["on-click", "disabled"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createVNode(TextButton, {
                      "button-style": 'btn-primary',
                      size: 'btn-md',
                      "on-click": 
                () => {
                  _ctx.registerSettingStore.onClickHomeInputSettingData('在庫');
                }
              ,
                      disabled: false,
                      class: "bulk-action-button-container__export-button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('在庫ファイルの取り込み設定')), 1)
                      ], undefined, true),
                      _: 1
                    }, 8, ["on-click"])
                  ]))
            ]))
          : (selectedInputSetting.value === 'SalesResults')
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                (_unref(state).homeInput.inputExcelInfo && _unref(state).homeInput.inputExcelInfo.SalesResults)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createVNode(InputExcelForm, {
                        from: 'HomeInput',
                        "selected-field-id": '',
                        suggestions: [],
                        "use-format-type": _unref(state).homeInput.inputExcelInfo?.SalesResults.selectYearMonthPattern,
                        "alterable-header-infos": _unref(state).homeInput.inputExcelInfo.SalesResults.alternateHeaderInfos,
                        "inlined-year-month-info": 
                _unref(state).homeInput.inputExcelInfo.SalesResults.inlinedYearMonthHeaderName || {
                  headerName: '',
                  validateError: 'none',
                }
              ,
                        "in-header-year-month-info": 
                _unref(state).homeInput.inputExcelInfo.SalesResults.inHeaderYearMonthInfo || {
                  startColumnNumber: {
                    raw: '',
                    validateError: 'none',
                  },
                  endColumnNumber: {
                    raw: '',
                    validateError: 'none',
                  },
                  start: {
                    raw: '',
                    validateError: 'none',
                  },
                  end: {
                    raw: '',
                    validateError: 'none',
                  },
                }
              ,
                        onUpdateInlineHeaderName: _cache[11] || (_cache[11] = ($event: any) => (updateInlineHeaderName('SalesResults', $event))),
                        onUpdateInHeaderStartColumnNumber: _cache[12] || (_cache[12] = ($event: any) => (updateInHeaderStartColumnNumber('SalesResults', $event))),
                        onUpdateInHeaderEndColumnNumber: _cache[13] || (_cache[13] = ($event: any) => (updateInHeaderEndColumnNumber('SalesResults', $event))),
                        onUpdateInHeaderStart: _cache[14] || (_cache[14] = ($event: any) => (updateInHeaderStart('SalesResults', $event))),
                        onUpdateInHeaderEnd: _cache[15] || (_cache[15] = ($event: any) => (updateInHeaderEnd('SalesResults', $event)))
                      }, null, 8, ["use-format-type", "alterable-header-infos", "inlined-year-month-info", "in-header-year-month-info"]),
                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "box-input-file-settings__separator" }, null, -1)),
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(TextButton, {
                          "button-style": 'btn-secondary',
                          size: 'btn-md',
                          "on-click": 
                  () => {
                    _ctx.registerSettingStore.onClickHomeInputSettingData('販売実績');
                  }
                ,
                          disabled: false
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('取引設定：取引設定ボタン')), 1)
                          ], undefined, true),
                          _: 1
                        }, 8, ["on-click"]),
                        _createVNode(TextButton, {
                          "button-style": 'btn-primary',
                          size: 'btn-md',
                          "on-click": 
                  () => {
                    _ctx.registerSettingStore.onClickHomeInputUpdateData('SalesResults');
                  }
                ,
                          disabled: !_unref(state).homeInput.isEdited.SalesResults
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('取引設定：年月情報変更ボタン')), 1)
                          ], undefined, true),
                          _: 1
                        }, 8, ["on-click", "disabled"])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createVNode(TextButton, {
                        "button-style": 'btn-primary',
                        size: 'btn-md',
                        "on-click": 
                () => {
                  _ctx.registerSettingStore.onClickHomeInputSettingData('販売実績');
                }
              ,
                        disabled: false,
                        class: "bulk-action-button-container__export-button"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('販売実績ファイルの取り込み設定')), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["on-click"])
                    ]))
              ]))
            : (selectedInputSetting.value === 'Arrival')
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  (_unref(state).homeInput.inputExcelInfo && _unref(state).homeInput.inputExcelInfo.Arrival)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createVNode(InputExcelForm, {
                          from: 'HomeInput',
                          "selected-field-id": '',
                          suggestions: [],
                          "use-format-type": _unref(state).homeInput.inputExcelInfo?.Arrival.selectYearMonthPattern,
                          "alterable-header-infos": _unref(state).homeInput.inputExcelInfo.Arrival.alternateHeaderInfos,
                          "inlined-year-month-info": 
                _unref(state).homeInput.inputExcelInfo.Arrival.inlinedYearMonthHeaderName || {
                  headerName: '',
                  validateError: 'none',
                }
              ,
                          "in-header-year-month-info": 
                _unref(state).homeInput.inputExcelInfo.Arrival.inHeaderYearMonthInfo || {
                  startColumnNumber: {
                    raw: '',
                    validateError: 'none',
                  },
                  endColumnNumber: {
                    raw: '',
                    validateError: 'none',
                  },
                  start: {
                    raw: '',
                    validateError: 'none',
                  },
                  end: {
                    raw: '',
                    validateError: 'none',
                  },
                }
              ,
                          onUpdateInlineHeaderName: _cache[16] || (_cache[16] = ($event: any) => (updateInlineHeaderName('Arrival', $event))),
                          onUpdateInHeaderStartColumnNumber: _cache[17] || (_cache[17] = ($event: any) => (updateInHeaderStartColumnNumber('Arrival', $event))),
                          onUpdateInHeaderEndColumnNumber: _cache[18] || (_cache[18] = ($event: any) => (updateInHeaderEndColumnNumber('Arrival', $event))),
                          onUpdateInHeaderStart: _cache[19] || (_cache[19] = ($event: any) => (updateInHeaderStart('Arrival', $event))),
                          onUpdateInHeaderEnd: _cache[20] || (_cache[20] = ($event: any) => (updateInHeaderEnd('Arrival', $event)))
                        }, null, 8, ["use-format-type", "alterable-header-infos", "inlined-year-month-info", "in-header-year-month-info"]),
                        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "box-input-file-settings__separator" }, null, -1)),
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(TextButton, {
                            "button-style": 'btn-secondary',
                            size: 'btn-md',
                            "on-click": 
                  () => {
                    _ctx.registerSettingStore.onClickHomeInputSettingData('入荷');
                  }
                ,
                            disabled: false
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('取引設定：取引設定ボタン')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["on-click"]),
                          _createVNode(TextButton, {
                            "button-style": 'btn-primary',
                            size: 'btn-md',
                            "on-click": 
                  () => {
                    _ctx.registerSettingStore.onClickHomeInputUpdateData('Arrival');
                  }
                ,
                            disabled: !_unref(state).homeInput.isEdited.Arrival
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('取引設定：年月情報変更ボタン')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["on-click", "disabled"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createVNode(TextButton, {
                          "button-style": 'btn-primary',
                          size: 'btn-md',
                          "on-click": 
                () => {
                  _ctx.registerSettingStore.onClickHomeInputSettingData('入荷');
                }
              ,
                          disabled: false,
                          class: "bulk-action-button-container__export-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('入荷ファイルの取り込み設定')), 1)
                          ], undefined, true),
                          _: 1
                        }, 8, ["on-click"])
                      ]))
                ]))
              : (selectedInputSetting.value === 'Order')
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    (_unref(state).homeInput.inputExcelInfo && _unref(state).homeInput.inputExcelInfo.Order)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createVNode(InputOrderExcelForm, {
                            from: "HomeInput",
                            "selected-field-id": "",
                            suggestions: [],
                            "order-excel-infos": _unref(state).homeInput.inputExcelInfo.Order,
                            onUpdateOrderExcelInfos: updateHomeOrderExcelInfos,
                            onRemoveOrderExcelInfo: removeHomeOrderExcelInfo,
                            onConfirmOrderExcelInfoName: confirmHomeOrderExcelInfoName
                          }, null, 8, ["order-excel-infos"]),
                          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "box-input-file-settings__separator" }, null, -1)),
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(TextButton, {
                              "button-style": 'btn-secondary',
                              size: 'btn-md',
                              "on-click": 
                  () => {
                    _ctx.registerSettingStore.onClickHomeInputSettingData('発注');
                  }
                ,
                              disabled: false
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('取引設定：取引設定ボタン')), 1)
                              ], undefined, true),
                              _: 1
                            }, 8, ["on-click"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createVNode(TextButton, {
                            "button-style": 'btn-primary',
                            size: 'btn-md',
                            "on-click": 
                () => {
                  _ctx.registerSettingStore.onClickHomeInputSettingData('発注');
                }
              ,
                            disabled: false,
                            class: "bulk-action-button-container__export-button"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('発注ファイルの取り込み設定')), 1)
                            ], undefined, true),
                            _: 1
                          }, 8, ["on-click"])
                        ]))
                  ]))
                : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(ResultRegisteredAnnounceModal, {
      state: _unref(importExcelState),
      onOnNext: _cache[21] || (_cache[21] = ($event: any) => (_unref(importExcelState).isOpenResultRegisteredAnnounceModal = false))
    }, null, 8, ["state"])
  ]))
}
}

})